
import {Component, Vue} from 'vue-property-decorator';
import {readAdminExternalUsers} from '@/store/admin/getters';
import {
  dispatchDeleteExternalUsersAdmin,
  dispatchGetExternalUsersAdmin,
} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';

@Component({
  components: {DynamicTable},
})
export default class ExternalUserList extends Vue {

  public headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false, width: '100px',
      router_name: 'main-admin-users-external-users-edit', delete_function: this.deleteExternalUser},
    {
      text: this.$t('username'),
      sortable: true,
      value: 'username',
      align: 'left',
      width: 100,
    },
    {
      text: this.$t('email'),
      sortable: true,
      value: 'email',
      align: 'left',
      width: 250,
    },
    {
      text: this.$t('fullName'),
      sortable: true,
      value: 'fullname',
      align: 'left',
      width: 250,
    },
    // {
    //   text: this.$t('committee_member'),
    //   sortable: true,
    //   value: 'committee_member',
    //   align: 'center',
    //   width: 250,
    // },
    {
      text: `${this.$t('professional_council')}`,
      sortable: false,
      value: 'professional_council',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('council_type')}`,
      sortable: false,
      value: 'council_type',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('ses_registration')}`,
      sortable: false,
      value: 'ses_registration',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('personal_document2')}`,
      sortable: false,
      value: 'personal_document',
      type: 'document',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('document2')}`,
      sortable: false,
      value: 'document',
      type: 'document',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('origin_location')}`,
      sortable: false,
      value: 'origin',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('observations')}`,
      sortable: false,
      value: 'observation',
      align: 'left',
      width: 100,
    },
  ];

  get externalUsers() {
    return readAdminExternalUsers(this.$store);
  }

  public async deleteExternalUser(id) {
    await dispatchDeleteExternalUsersAdmin(this.$store, id);
    await dispatchGetExternalUsersAdmin(this.$store);
  }

  public async mounted() {
    await dispatchGetExternalUsersAdmin(this.$store);
  }
}
